import React, { useEffect, useRef, useState } from "react";
import TeamDetailsDirectorPartnerDetails from "../TeamDetailsDirectorPartnerDetails/TeamDetailsDirectorPartnerDetails";
import TeamDetailsCurrentAddress from "../TeamDetailsCurrentAddress/TeamDetailsCurrentAddress";
import TeamsPermanentsAddress from "../TeamsPermanentsAddress/TeamsPermanentsAddress";
import TeamsPanVerification from "../TeamsPanVerification/TeamsPanVerification";
import TeamAadharVerification from "../TeamAadharVerification/TeamAadharVerification";
import PartnerPortalStatusBar from "../PartnerPortalStatusBar/PartnerPortalStatusBar";
import {
  getTeamsAadharDetailAll,
  getTeamsDirectDetail,
  getTeamsPanDetailAll,
} from "../../redux/TeamDetailsMaster/action";
import { teamsDetailMaster } from "../../redux/TeamDetailsMaster/action";
import {
  getSideBarBranch,
  getTeamSideBarDetails,
} from "../../redux/SideBarTeams/action";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import { nextPage } from "../../redux/NextPage/NextPageAction";
import { Spin, notification } from "antd";
import UiButton from "./../Common/UiButton/UiButton";
import {
  getPermanentAddressTeams,
  getCurrentAddressTeams,
} from "./../../redux/TeamDetails/action";
import useWindowSize from "../../utils/useWindowSize";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Row } from "reactstrap";
import { teamSaveAllDetails } from "../../redux/TeamSaveAll/TeamSaveAllActions";
import UseFullLoader from "../FullPageLoader/UseFullLoader";
import useSession from "../CustomLogout/useSession";

const PartnerTeamDetails = (props) => {
  const handleSessionExpired = useSession();

  const [loading, setLoading] = useState(true);

  const [saveAllIndication, setSaveAllIndication] = useState(false);
  const [saveAllLoading, setSaveAllLoading] = useState(false);
  const [saveAllError, setSaveAllError] = useState("");
  const [apiCalled, setApiCalled] = useState(false);

  const [handleGetTeamDirector, setHandleGetTeamDirector] = useState(null);
  const [handleGetTeamAddress, setHandleGetTeamAddress] = useState(null);
  const [handleGetTeamPan, setHandleGetTeamPan] = useState(null);
  const [handleGetTeamAadhar, setHandleGetTeamAadhar] = useState(null);
  const [loader, showLoader, hideLoader] = UseFullLoader();

  useEffect(() => {
    if (
      handleGetTeamDirector &&
      handleGetTeamAddress &&
      handleGetTeamPan &&
      // handleGetTeamAadhar &&
      apiCalled
    ) {
      setApiCalled(false);
      setSaveAllError("");
      const formValue = {
        partnerTeamPersonMasterDTO: {
          partnerPersonId: location?.state?.teamId ?? null,
          permanentAddressDTO: handleGetTeamAddress?.permanentAddressDTO,
          currentAddressDTO: handleGetTeamAddress?.currentAddressDTO,
          personDateofBirth: handleGetTeamDirector?.personDateofBirth,
          personFullName: handleGetTeamDirector?.personFullName,
          personQualification: handleGetTeamDirector?.personQualification,
          personSalutation: handleGetTeamDirector?.personSalutation,
          relatedAFSLEmployeeName:
            handleGetTeamDirector?.relatedAFSLEmployeeName,
          relativeOfAFSLEmployeeFlag:
            handleGetTeamDirector?.relativeOfAFSLEmployeeFlag,
        },
        partnerTeamPanDetailsDTO: handleGetTeamPan,
        partnerTeamAadharDetailsDTO:
          handleGetTeamAadhar?.partnerTeamAadhaarConsent
            ? handleGetTeamAadhar
            : null,
      };
      setSaveAllLoading(true);
      showLoader();

      let params = {
        partnerFirmId: props.firmId || Id,
      };

      props
        .teamSaveAllDetails({
          accessToken: props.accessToken,
          params: params,
          values: formValue,
        })
        .then((res) => {
          setSaveAllLoading(false);
          if (res?.status === 200) {
            hideLoader();
            message.destroy();
            message.success("Save all Details Successfully!!");
            nextPage();
            setSaveAllIndication(false);
            props
              .getSideData({
                accessToken: props.accessToken,
                partnerFirmId: props?.firmId || Id,
              })
              .then((res) => {
                // Handle the response here

                if (res?.data?.error || res?.message) {
                  const errorCode =
                    res?.data?.error?.errorCode || res?.errorCode;
                  const errorMessage =
                    res?.data?.error?.message || res?.message;

                  if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                    hideLoader();

                    handleSessionExpired();
                  } else {
                    notification.error({
                      description: errorMessage,
                      duration: 5,
                      placement: "top",
                    });
                  }
                }

                // ...
              });

            props.getSideData({
              accessToken: props.accessToken,
              partnerFirmId: props?.firmId || Id,
            });
          } else {
            hideLoader();
            setSaveAllLoading(false);
            setSaveAllError(res?.message);
            setSaveAllIndication(false);
          }

          if (res?.data?.error || res?.message) {
            const errorCode = res?.data?.error?.errorCode || res?.errorCode;
            const errorMessage = res?.data?.error?.message || res?.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          hideLoader();
          setSaveAllLoading(false);
          message.destroy();
          // message.error("Kindly Fill The Team Details");
          setSaveAllError(err?.message);
          setSaveAllIndication(false);
        });
      setSaveAllIndication(false);
    } else {
      if (saveAllIndication) {
        setSaveAllError("Kindly Fill all the mandatory fields of Team Details");
        setApiCalled(false);
        hideLoader();
      }
      // executeScroll();
      setSaveAllIndication(false);
      hideLoader();
      setHandleGetTeamDirector(null);
      setHandleGetTeamAddress(null);
      setHandleGetTeamPan(null);
      setHandleGetTeamAadhar(null);
    }
  }, [
    handleGetTeamDirector,
    handleGetTeamAddress,
    handleGetTeamPan,
    // handleGetTeamAadhar,
    saveAllIndication,
  ]);

  const history = useNavigate();
  const Id = sessionStorage.getItem("cetFirmId");

  let location = useLocation();
  const id = location?.state?.partnerFirmId;

  const myRef = useRef(null);
  const executeScroll = () => myRef?.current?.scrollIntoView();

  const { width } = useWindowSize();
  const mobile = width < 786;

  useEffect(() => {
    // if (!mobile) {
    executeScroll();
    // }
  }, [mobile, loading, id]);

  const nextPage = () => {
    // setLoading(true);
    // message.loading("please wait...", 0);
    let data = {
      stageName: "TEAM_DETAILS",
      stage: "Team Details",
      page: "TeamDetails",
      status: "COMPLETE",
      partnerFirmId: props.firmId || Id,
    };
    props
      .nextPageRedirect({
        accessToken: props.accessToken,
        partnerFirmId: props.firmId || Id,
        data: data,
      })
      .then((res) => {
        message.destroy();
        if (res?.status === 200) {
          history("/PartnerDashboard/document");
        }
        if (res?.data?.error || res?.message) {
          const errorCode = res?.data?.error?.errorCode || res?.errorCode;
          const errorMessage = res?.data?.error?.message || res?.message;
          hideLoader();

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const [Auth, setAuth] = useState(useSelector((state) => state.auth));

  const [teamDetails, setTeamDetails] = useState(
    useSelector((state) => state.teamSideBar)
  );

  useEffect(() => {
    if (location.state !== null) {
      props
        .getDirectorDetail(
          Auth.accessToken.access_token,
          Auth?.checkLogin?.partnerFirmId,
          location?.state?.teamId
        )
        .then((res) => {
          props
            .getPan({
              access_token: Auth.accessToken.access_token,
              personId: location?.state?.teamId,
            })
            .then((res) => {
              props
                .getAdhar({
                  access_token: Auth.accessToken.access_token,
                  personId: location?.state?.teamId,
                })
                .then((res) => {
                  props
                    .getCurrent({
                      access_token: Auth.accessToken.access_token,
                      personId: location?.state?.teamId,
                    })
                    .then((res) => {
                      props
                        .getPermanent({
                          access_token: Auth.accessToken.access_token,
                          personId: location?.state?.teamId,
                        })
                        .then((res) => {
                          setLoading(false);
                          if (res?.data?.error || res?.message) {
                            const errorCode =
                              res?.data?.error?.errorCode || res?.errorCode;
                            const errorMessage =
                              res?.data?.error?.message || res?.message;
                            hideLoader();

                            if (
                              errorCode === "403" &&
                              res?.data?.error?.logoutStatus
                            ) {
                              hideLoader();

                              handleSessionExpired();
                            } else {
                              notification.error({
                                description: errorMessage,
                                duration: 5,
                                placement: "top",
                              });
                            }
                          }
                        });
                      if (res?.data?.error || res?.message) {
                        const errorCode =
                          res?.data?.error?.errorCode || res?.errorCode;
                        const errorMessage =
                          res?.data?.error?.message || res?.message;

                        if (
                          errorCode === "403" &&
                          res?.data?.error?.logoutStatus
                        ) {
                          hideLoader();

                          handleSessionExpired();
                        } else {
                          notification.error({
                            description: errorMessage,
                            duration: 5,
                            placement: "top",
                          });
                        }
                      }
                    });
                  if (res?.data?.error || res?.message) {
                    const errorCode =
                      res?.data?.error?.errorCode || res?.errorCode;
                    const errorMessage =
                      res?.data?.error?.message || res?.message;

                    if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                      hideLoader();

                      handleSessionExpired();
                    } else {
                      notification.error({
                        description: errorMessage,
                        duration: 5,
                        placement: "top",
                      });
                    }
                  }
                });
              if (res?.data?.error || res?.message) {
                const errorCode = res?.data?.error?.errorCode || res?.errorCode;
                const errorMessage = res?.data?.error?.message || res?.message;

                if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                  hideLoader();

                  handleSessionExpired();
                } else {
                  notification.error({
                    description: errorMessage,
                    duration: 5,
                    placement: "top",
                  });
                }
              }
            });

          if (res?.data?.error || res?.message) {
            const errorCode = res?.data?.error?.errorCode || res?.errorCode;
            const errorMessage = res?.data?.error?.message || res?.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    } else {
      setLoading(false);
    }
  }, [location?.state?.teamId]);

  useEffect(() => {
    if (location?.state?.teamId) {
      setSaveAllError("");
    }
  }, [location?.state?.teamId]);

  useEffect(() => {
    props.getData(Auth.accessToken.access_token);
  }, []);

  const handleSaveAll = () => {
    setSaveAllIndication(true);
    setApiCalled(true);
  };

  return !loading ? (
    <div ref={myRef}>
      {loader}
      <PartnerPortalStatusBar
        percent={80}
        lable={"80% Registration Completed"}
      />
      <div className="container-main">
        <TeamDetailsDirectorPartnerDetails
          qualificationList={props.data?.masterData?.academicsList}
          salutationList={props.data?.masterData?.salutationList}
          personId={location?.state?.teamId}
          saveAllIndication={saveAllIndication}
          setHandleGetTeamDirector={setHandleGetTeamDirector}
        />
        <TeamDetailsCurrentAddress
          personId={location?.state?.teamId}
          saveAllIndication={saveAllIndication}
          setHandleGetTeamAddress={setHandleGetTeamAddress}
        />
        {/* <TeamsPermanentsAddress /> */}
        <TeamsPanVerification
          personId={location?.state?.teamId}
          saveAllIndication={saveAllIndication}
          setHandleGetTeamPan={setHandleGetTeamPan}
        />
        {/* <TeamAadharVerification
          personId={location?.state?.teamId}
          saveAllIndication={saveAllIndication}
          setHandleGetTeamAadhar={setHandleGetTeamAadhar}
        /> */}
        {/* <UiButton type="button" title="Next" onClick={nextPage} /> */}
        <Row className="sumit-all-row">
          <Col md={8} className="text-error">
            {saveAllError && <p>{saveAllError}</p>}
          </Col>
          <Col md={2} className="save-next-btn">
            {saveAllLoading && (
              <div className="pr-4 spanner">
                <Spin
                  size="large"
                  className="pr-4"
                  indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                ></Spin>
              </div>
            )}
          </Col>
          <Col md={2} className="save-next-btn">
            <UiButton
              type="button"
              title="Save All & Next"
              onClick={handleSaveAll}
            />
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin
        size="large"
        indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
      ></Spin>{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    nextPageRedirect: (user) => dispatch(nextPage(user)),
    getData: (accessToken) => dispatch(teamsDetailMaster(accessToken)),
    getTeamsData: (data) => dispatch(getTeamSideBarDetails(data)),
    getDirectorDetail: (accessToken, parnterFirmID, partnerPersonId) =>
      dispatch(
        getTeamsDirectDetail(accessToken, parnterFirmID, partnerPersonId)
      ),
    getPermanent: (data) => dispatch(getPermanentAddressTeams(data)),
    getPan: (data) => dispatch(getTeamsPanDetailAll(data)),
    getAdhar: (data) => dispatch(getTeamsAadharDetailAll(data)),
    getCurrent: (data) => dispatch(getCurrentAddressTeams(data)),
    teamSaveAllDetails: (data) => dispatch(teamSaveAllDetails(data)),
    getSideData: (details) => dispatch(getSideBarBranch(details)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state.auth,
    data: state.teamsMasterData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    accessToken: state && state.auth && state.auth.idToken,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerTeamDetails);
